import { render, staticRenderFns } from "./SocialRewards.vue?vue&type=template&id=e30ba8ae&scoped=true&"
import script from "./SocialRewards.vue?vue&type=script&lang=ts&"
export * from "./SocialRewards.vue?vue&type=script&lang=ts&"
import style0 from "./SocialRewards.vue?vue&type=style&index=0&id=e30ba8ae&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e30ba8ae",
  null
  
)

export default component.exports